"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Encrypt = (salt, text) => {
    try {
        return btoa(salt + text);
    }
    catch (err) {
        return Buffer.from(salt + text).toString('base64');
    }
};
const Decrypt = (salt, encoded) => {
    try {
        return atob(salt + encoded);
    }
    catch (err) {
        return Buffer.from(salt + encoded, 'base64').toString();
    }
};
exports.default = {
    Encrypt,
    Decrypt
};
